/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Document, Outline, Page, pdfjs } from 'react-pdf';
import { SizeMe } from 'react-sizeme';
import { Grid, IconButton } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { getPdfWorkerSrc } from '@shared/utils/helpers/pdfWorker';

// Воркер берём со своего домена (public/pdf.worker.min.js), а не с CDN — см. pdfWorker.ts.
pdfjs.GlobalWorkerOptions.workerSrc = getPdfWorkerSrc(pdfjs.version);

interface Props {
  pdfBase64: any;
}

export const PdfView: React.FC<Props> = ({ pdfBase64 }) => {
  const [blob, setBlob] = useState<any>(null);
  const [numPages, setNumPages] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onLoadSuccess = async (successEvent: any) => {
    const data = await successEvent.getData();
    const b = new Blob([data], { type: 'application/pdf' });
    setBlob(b);
    setNumPages(successEvent.numPages);
    setPageNumber(1);
    // window.open(URL.createObjectURL(blob));
  };

  const changePage = (offset: number) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    changePage(-1);
  };

  const nextPage = () => {
    changePage(1);
  };

  const onItemClick = ({ pageNumber: itemPageNumber }) => {
    setPageNumber(itemPageNumber);
  };

  return (
    <Grid className={'justify-center items-center'} container direction="row">
      <Grid item xs={12}>
        <SizeMe
          render={({ size }) => (
            <div>
              {pdfBase64 && (
                <Document file={`data:application/pdf;base64,${pdfBase64}`} onLoadSuccess={onLoadSuccess}>
                  <Outline onItemClick={onItemClick} />
                  <Page width={size.width ? size.width : 1} pageNumber={pageNumber || 1} />
                </Document>
              )}
            </div>
          )}
        />
        <Grid className={'justify-center items-center'} container direction="row">
          <Grid item xs={6}>
            <p>
              Страница {pageNumber || (numPages ? 1 : '--')} из {numPages || '--'}
            </p>
          </Grid>
          {numPages > 1 && (
            <Grid item xs={6}>
              <IconButton aria-label="previous" size="small" disabled={pageNumber <= 1} onClick={previousPage}>
                <KeyboardArrowLeftIcon />
              </IconButton>
              <IconButton aria-label="next" size="small" disabled={pageNumber >= numPages} onClick={nextPage}>
                <KeyboardArrowRightIcon />
              </IconButton>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
